import { joinPathsStringUtil } from 'packages/src'

export const SUBSCRIPTION_CANCELLATION_DOMAIN_NAME = 'subscriptionCancellation'

export const SUBSCRIPTION_CANCELLATION_KEY = {
  REASON: 'reason',
  HAS_ACCEPTED_RETENTION_OFFER: 'hasAcceptedRetentionOffer',
  FEEDBACK: 'feedback'
}

export const SUBSCRIPTION_CANCELLATION_PATH = {
  [SUBSCRIPTION_CANCELLATION_KEY.REASON]: joinPathsStringUtil(
    SUBSCRIPTION_CANCELLATION_DOMAIN_NAME,
    SUBSCRIPTION_CANCELLATION_KEY.REASON
  ),
  [SUBSCRIPTION_CANCELLATION_KEY.HAS_ACCEPTED_RETENTION_OFFER]: joinPathsStringUtil(
    SUBSCRIPTION_CANCELLATION_DOMAIN_NAME,
    SUBSCRIPTION_CANCELLATION_KEY.HAS_ACCEPTED_RETENTION_OFFER
  ),
  [SUBSCRIPTION_CANCELLATION_KEY.FEEDBACK]: joinPathsStringUtil(
    SUBSCRIPTION_CANCELLATION_DOMAIN_NAME,
    SUBSCRIPTION_CANCELLATION_KEY.FEEDBACK
  )
}

export const SUBSCRIPTION_CANCELLATION_STATE = {
  [SUBSCRIPTION_CANCELLATION_KEY.REASON]: '',
  [SUBSCRIPTION_CANCELLATION_KEY.HAS_ACCEPTED_RETENTION_OFFER]: null,
  [SUBSCRIPTION_CANCELLATION_KEY.FEEDBACK]: ''
}
